import React, { SyntheticEvent, useContext, useState } from "react";

import { Alert, Button, CircularProgress, Grid, Snackbar } from "@mui/material";
import { useParams } from "react-router-dom";

import SubscriptionAction from "./subscription-action";
import { pauseSalesForceSyncMethod } from "api/endpoints/subscription";
import { callOptionsHeaders } from "api/helpers";
import { DEFAULT_SNACKBAR_DURATION, EventTypeReason } from "constants/index";
import { SnackbarContext } from "context/snackbar-context";
import { UrlParamTypes } from "types/org-display";

const PauseSync = () => {
  const { regionCode, roleId } = useParams<UrlParamTypes>();
  const [showLoadingSpinner, setShowLoadingSpinner] = useState(false);
  const { showError } = useContext(SnackbarContext);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);

  const handleClose = (
    event?: Event | SyntheticEvent<unknown, Event>,
    reason?: string | undefined
  ) => {
    if (reason === EventTypeReason.Clickaway) {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const handleUpdateProductPlanReq = () => {
    setShowLoadingSpinner(true);
    pauseSalesForceSyncMethod(
      {
        organizationId: roleId,
      },
      callOptionsHeaders(regionCode)
    )
      .then(() => {
        setOpenSuccessAlert(true);
      })
      .catch(showError)
      .finally(() => {
        setShowLoadingSpinner(false);
      });
  };

  return (
    <React.Fragment>
      <SubscriptionAction title="Pause SalesForce Sync:">
        {showLoadingSpinner ? (
          <Grid container justifyContent="center" sx={{ mt: 1, mr: 2 }}>
            <CircularProgress
              color="primary"
              variant="indeterminate"
              thickness={4}
              size={30}
            />
          </Grid>
        ) : (
          <Button
            sx={{ mt: 1, mr: 2 }}
            variant="contained"
            color="primary"
            fullWidth
            onClick={() => handleUpdateProductPlanReq()}
            data-testid="sync-payment-method-btn"
          >
            Pause SalesForce Sync
          </Button>
        )}

        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          open={openSuccessAlert}
          autoHideDuration={DEFAULT_SNACKBAR_DURATION}
          onClose={handleClose}
          data-testid="snackbar-change-product-type"
        >
          <Alert severity="success" variant="filled">
            SF Sync paused for 1 hour
          </Alert>
        </Snackbar>
      </SubscriptionAction>
    </React.Fragment>
  );
};

export default PauseSync;
